import { clsx } from 'clsx';
import { FC, useEffect, useState } from 'react';
import { Span } from 'atoms/Typography';
import { ShippingInfo } from 'molecules/ShippingInfo';
import { useTooltipStore } from 'molecules/Tooltip/store';
import { useTranslations } from 'modules/i18n/useTranslations';
import { Tooltip } from '../Tooltip';
import styles from './styles.module.css';

interface IProps {
  className?: string;
  rate: number;
  referenceKey?: string;
}

export const Vat: FC<IProps> = ({ className, rate = 0, referenceKey }) => {
  const t = useTranslations();
  // reduce amount of elements on listing page
  const [isMounted, setMounted] = useState(false);
  const { tooltipId, setTooltipId } = useTooltipStore();
  const [isOpen, setIsOpen] = useState(tooltipId === referenceKey);
  const open = tooltipId === referenceKey && isOpen;

  const handleTooltipOpen = () => {
    setTooltipId(referenceKey);
    setIsOpen(true);
  };

  const handleTooltipClose = () => {
    setTooltipId(null);
    setIsOpen(false);
  };

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <div className={clsx(styles.vat, className)}>
      {t('product.tile.vat', { rate })}{' '}
      {isMounted ? (
        <Tooltip
          onClose={handleTooltipClose}
          open={open}
          element={<ShippingInfo />}
        >
          <Span onClick={handleTooltipOpen} className={styles.vatInfo}>
            {t('product.tile.vat-link')}
          </Span>
        </Tooltip>
      ) : (
        <Span onClick={handleTooltipOpen} className={styles.vatInfo}>
          {t('product.tile.vat-link')}
        </Span>
      )}
    </div>
  );
};
